export const SUPLA_VISUALS = {
  valve: '/media/optimized/bc37b8ae4_generated_image.webp',
  shaft: '/media/optimized/1ec603a65_generated_image.webp',
  modules: '/media/optimized/c0302045c_generated_image.webp',
};